import type { FC } from 'react';
import React from 'react';
import { StyledRemoveSpinner } from './RotatingRingLoader.styles';

type RotatingRingLoaderProps = Readonly<{
  width?: string;
  height?: string;
  borderWidth?: string;
  borderColor?: string;
  thumbColor?: string;
  thumbZIndex?: number;
  trackZIndex?: number;
}>;

export const RotatingRingLoader: FC<RotatingRingLoaderProps> = props => {
  const { width = '30px', height = '30px', borderWidth = '3px', borderColor = '#c4c4c4', thumbColor = '#5f2698', thumbZIndex, trackZIndex } = props;

  return (
    <StyledRemoveSpinner
      width={width}
      height={height}
      borderWidth={borderWidth}
      borderColor={borderColor}
      thumbColor={thumbColor}
      thumbZIndex={thumbZIndex}
      trackZIndex={trackZIndex}
    >
      <div />
      <div />
      <div />
    </StyledRemoveSpinner>
  );
};
